import React, { useEffect, createElement } from 'react';
import { Routes, Route, Navigate, useSearchParams, useNavigate } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { UpsellPage } from './pages/UpsellPage';
import { Inmunidad27Page } from './pages/Inmunidad27Page';
import { Upsell1InmunidadPage } from './pages/Upsell1InmunidadPage';
import { ThankYou1Page } from './pages/ThankYou1Page';
import { InmunidadTot27Page } from './pages/InmunidadTot27Page';
import { Oportunidad1Page } from './pages/Oportunidad1Page';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
function QueryParamRedirect() {
  const [searchParams] = useSearchParams();
  const pageParam = searchParams.get('page');
  const paramMap: Record<string, string> = {
    inmunidadtot: '/inmunidadtot',
    immunitytot: '/inmunidadtot',
    inmunidad27: '/inmunidad27',
    immunity27: '/inmunidad27',
    up1inmunidad: '/up1inmunidad',
    up1immunity: '/up1inmunidad',
    inmunidadtot27: '/inmunidadtot27',
    oportunidad1: '/oportunidad1',
    thankyou1: '/thankyou1'
  };
  if (pageParam && paramMap[pageParam]) {
    return <Navigate to={paramMap[pageParam]} replace data-id="element-0" />;
  }
  return <>
      <SalesPage data-id="element-1" />
      <RecentPurchaseToast data-id="element-2" />
    </>;
}
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-558L5RR8');`;
    document.head.appendChild(gtmScript);
  }, []);
  return <Routes data-id="element-3">
      {/* Main routes */}
      <Route path="/" element={<QueryParamRedirect data-id="element-5" />} data-id="element-4" />
      <Route path="/inmunidadtot" element={<UpsellPage data-id="element-7" />} data-id="element-6" />
      <Route path="/inmunidad27" element={<Inmunidad27Page data-id="element-9" />} data-id="element-8" />
      <Route path="/up1inmunidad" element={<Upsell1InmunidadPage data-id="element-11" />} data-id="element-10" />
      <Route path="/inmunidadtot27" element={<InmunidadTot27Page data-id="element-13" />} data-id="element-12" />
      <Route path="/oportunidad1" element={<Oportunidad1Page data-id="element-15" />} data-id="element-14" />
      <Route path="/thankyou1" element={<ThankYou1Page data-id="element-17" />} data-id="element-16" />

      {/* Path aliases — redirect to canonical routes */}
      <Route path="/immunitytot" element={<Navigate to="/inmunidadtot" replace data-id="element-19" />} data-id="element-18" />
      <Route path="/immunity27" element={<Navigate to="/inmunidad27" replace data-id="element-21" />} data-id="element-20" />
      <Route path="/up1immunity" element={<Navigate to="/up1inmunidad" replace data-id="element-23" />} data-id="element-22" />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace data-id="element-25" />} data-id="element-24" />
    </Routes>;
}